module.exports = __webpack_public_path__ + "img/badge_dropsandwins.a8fc0f6b.png";